import Visible from '@portalterreno/react-ui/Visible';
import Image from 'next/image';
import React from 'react';

const BaseLogo: React.FC = () => {
  return (
    <React.Fragment>
      <Visible desktop>
        <Image
          alt='PortalTerreno Logo'
          src={`${process.env.NEXT_PUBLIC_IMAGES_HOST}/logo.svg`}
          width={231}
          height={31}
        />
      </Visible>
      <Visible mobile>
        <Image
          alt='PortalTerreno Logo'
          src={`${process.env.NEXT_PUBLIC_IMAGES_HOST}/logo.svg`}
          width={183}
          height={24}
        />
      </Visible>
    </React.Fragment>
  );
};

export default BaseLogo;
